import axios, { AxiosError, CanceledError } from "axios";
import {PopUpType} from "../Models/Enums/PopUpType";
import IPopUpDTO from "../Models/DTOs/IPopUpDTO";
import config from "../Constants/Config";
import type { ActivePopupsResponse } from "../Models/DTOs/ActivePopupDTO";

const BACKEND_URL = process.env.REACT_APP_API_URL + config.popups;
const WEB_API_BASE = (process.env.REACT_APP_WEB_API_URL ?? "").replace(/\/$/, "");

/**
 * Fetches the popups eligible for the current page, time and login state.
 *
 * Pass the user's access token when logged in so audience gating returns the
 * correct targeting — a missing/invalid token is treated as logged-out by the
 * endpoint (it never fails on a bad token). Items arrive highest-priority first.
 */
export async function GetActivePopups(
    path: string,
    token: string | null,
    abortController: AbortController
): Promise<ActivePopupsResponse | AxiosError> {
    try {
        const url = `${WEB_API_BASE}/v1/popups/active?path=${encodeURIComponent(path)}`;
        const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

        const res = await axios.get<ActivePopupsResponse>(url, {
            signal: abortController.signal,
            headers,
        });

        return res.data;
    } catch (err: unknown) {
        // Intentional aborts are not errors — bubble up quietly.
        if (err instanceof CanceledError) return err;
        if (axios.isAxiosError(err)) return err;
        return new AxiosError("Non-Axios error", "ERR_UNKNOWN");
    }
}

export default async function GetPopUpApiData(abortController: AbortController, apiEnum: PopUpType | undefined) {
    const fetchUrl = BACKEND_URL + apiEnum;
    //console.log(fetchUrl);

    const response = await axios
        .get<IPopUpDTO>(fetchUrl, {
            signal: abortController.signal,
        })
        .then((response) => {
            return response.data as IPopUpDTO;
        })
        .catch((error: AxiosError) => {
            console.log("Email error");
            return error;
        });

    return response;
}